import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import PublicSite from "./pages/public/PublicSite";
import Booking from "./pages/public/Booking";
import Privacy from "./pages/public/Privacy";
import Cancel from "./pages/public/Cancel";
import Feedback from "./pages/public/Feedback";
import AdminLogin from "./pages/admin/Login";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import CalendarPage from "./pages/admin/Calendar";
import Availability from "./pages/admin/Availability";
import Treatments from "./pages/admin/Treatments";
import Customers from "./pages/admin/Customers";
import Gallery from "./pages/admin/Gallery";
import Reviews from "./pages/admin/Reviews";
import Settings from "./pages/admin/Settings";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/boeken" element={<Booking />} />
          <Route path="/privacybeleid" element={<Privacy />} />
          <Route path="/annuleren/:token" element={<Cancel />} />
          <Route path="/feedback/:token" element={<Feedback />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="agenda" element={<CalendarPage />} />
            <Route path="beschikbaarheid" element={<Availability />} />
            <Route path="behandelingen" element={<Treatments />} />
            <Route path="klanten" element={<Customers />} />
            <Route path="galerij" element={<Gallery />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="instellingen" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
